import { productRecommendationsLarge } from "../utilities/carouselSlickConfig";
import { initCarouselProductPrimaryUnit } from "../utilities/carouselPrimaryUnit";
import { syncHeightCarouselTiles } from "../utilities/globalUtilities";
import { getNewProductQtyMap } from "../utilities/ProductQtyMap";
import { triggerInitWishlistTogglers } from "../wishlist/wishlist";

var tabs = require("../utilities/tabs");

/**
 * Steps events: edit, next
 */
const initRecommendationsCarousel = () => {
    $(".product-recommendations-carousel").each((i, element) => {
        const $this = $(element);
        const tilesNumber = $this.data("tiles-number");
        const brandID = $this.data("brandid");
        const carouselTypeConfig = productRecommendationsLarge(tilesNumber, brandID);
        syncHeightCarouselTiles($this);
        initCarouselProductPrimaryUnit($this);

        const $carousels = $this.not(".slick-initialized");
        
        $carousels.parent().parent().find(".js-productcarousel-skeleton").addClass("d-none");
        $carousels.parent().find(".js-productcarousel-skeleton").addClass("d-none");
        $carousels.find(".js-productcarousel-skeleton").addClass("d-none");

        $carousels.slick(carouselTypeConfig);
    });
};

/**
 * Initialize MTabs on PDP
 */
const initMTabsPDP = () => {
    var pdpDetailsConfig = tabs.mobileAccordionTabsConfig;
    $(".js-description-tabs").mTab(pdpDetailsConfig);
};

/**
 * Handles the actions on product recommendations on PDP after they load
 */
const handlePDPRecommendationsSetup = () => {
    // set red borders to the tiles, if any is in basket
    if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
        const productQtyMap = getNewProductQtyMap();
        $("body").trigger("product:syncTileData", productQtyMap);
    }

    // reinit events
    initRecommendationsCarousel();

    //GTM custom event - start
    document.dispatchEvent(new Event("dataLayer.pdpRecommendation"));
    //GTM custom event - end

    setTimeout(() => {
        triggerInitWishlistTogglers();
    }, 200);
};

/**
 * Trigger selection of color variation if there is only one available
 */
const triggerSelectionOfOnlyColor = () => {
    const $quickviewContainer = $(".js-product-quickview");
    const isQuickViewOpened = $quickviewContainer && $quickviewContainer.length > 0 && $quickviewContainer.is(":visible");
    const $container = isQuickViewOpened ? $quickviewContainer : $(".product-detail");
    const $colorOptions = $container.find(".pwc-pdp--color-swatches button, .pwc-pdp--color-swatches a.quickview");

    if ($colorOptions.length == 1 && !$colorOptions.hasClass("selected")) {
        $colorOptions.trigger("click");
    }
};

export { initRecommendationsCarousel, initMTabsPDP, handlePDPRecommendationsSetup, triggerSelectionOfOnlyColor };
